module.exports = __webpack_public_path__ + "static/media/selectable-images.47409d67.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/selectable-images.md
// module id = 399
// module chunks = 0